import React from "react";
  import { BsFacebook, BsYoutube} from "react-icons/bs";
  import FooterLogo from '../assets/images/footer_logo.jpg';
  
  export const Footer = () => {
    const currentYear = new Date().getFullYear();
  
    return (
      <footer className="bg-[#b8dde3] py-8 mt-24">
        <div className="container max-w-6xl mx-auto flex flex-col items-center gap-4 text-center">
          <div className="flex justify-center w-full mb-6">
            <img 
              src={FooterLogo} 
              alt="Company Logo" 
              className="w-full max-w-[1600px] h-auto max-h-[180px] md:w-96 lg:w-96"
            />
          </div>
  
          <div className="flex gap-4 mb-4">
          <a
              href="https://www.youtube.com/@asiridevinda6400"
              className="text-gray-700 hover:text-black transition-colors"
              aria-label="Facebook"
            >
              <BsYoutube size={20} />
            </a>
            <a
              href="https://web.facebook.com/profile.php?id=100091257086281"
              className="text-gray-700 hover:text-black transition-colors"
              aria-label="Facebook"
            >
              <BsFacebook size={20} />
            </a>

          </div>
  
          <div className="text-xs text-gray-700">
            {/* <p>Email: contact@example.com</p> */}
            <p>Phone: 0770555783</p>
          </div>
  
          <div className="text-xs text-gray-700">
            <p>
              &copy; {currentYear} Developed by Rajith Sanjaya. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  };
